import { createFileRoute } from '@tanstack/react-router';
import { MessagesListPage } from '@/features/messages/messages-list-page.js';

export const Route = createFileRoute('/_app/messages/')({
  component: MessagesListPage,
});
